var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsSmlIconSearchField(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.28,
    height: 18.26,
    viewBox: "0 0 18.28 18.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.35,7.77a5.89,5.89,0,1,1-9.16-4.9,6,6,0,0,1,3.27-1,5.84,5.84,0,0,1,2.26.45,5.87,5.87,0,0,1,3.19,3.18,6.06,6.06,0,0,1,.44,2.26Z",
    transform: "translate(-1.08 -0.88)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38,16.37a1,1,0,0,0-.3.73,1,1,0,0,0,1,1,1,1,0,0,0,.73-.3l2.7-2.7a.7.7,0,0,0,0-1l-.49-.49a.7.7,0,0,0-.49-.2.68.68,0,0,0-.49.2Z",
    transform: "translate(-1.08 -0.88)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22,12,6.61,13.61",
    transform: "translate(-1.08 -0.88)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsSmlIconSearchField);
export default __webpack_public_path__ + "static/media/ws-sml-icon-search-field.b119d849e6a5125a50aa01252d0fd198.svg";
export { ForwardRef as ReactComponent };